import request from '@/utils/request'

// 留言咨询查询
export function informations(query) {
    return request({
        url: '/information/informations',
        method: 'get',
        params: query
    })
}

// 留言咨询查看
export function informationView(query) {
    return request({
        url: '/information/informationView',
        method: 'get',
        params: query
    })
}

// 留言咨询更新
export function informationEdit(data) {
    return request({
        url: '/information/informationEdit',
        method: 'post',
        data
    })
}

// 留言咨询删除
export function informationDrop(query) {
    return request({
        url: '/information/informationDrop',
        method: 'delete',
        params: query
    })
}
